
import { auth } from '../config/firebase';

// Use the same env-based API URL as api.ts so production builds point to Cloud Run
const API_BASE_URL = `${import.meta.env.VITE_API_BASE_URL || ''}/api`;

export type UploadType = 'image' | 'document' | 'video';

export const uploadService = {
    async uploadFile(file: File, type: UploadType): Promise<{ url: string, filename: string, signed_url?: string }> {
        const formData = new FormData();
        formData.append('file', file);

        // Select endpoint
        let endpoint = '/upload/image';
        let folder = 'uploads';

        if (type === 'document') {
            endpoint = '/upload/document';
            folder = 'documents';
        } else if (type === 'video') {
            endpoint = '/upload/video';
            folder = 'videos';
        }

        formData.append('folder', folder);

        try {
            // Get Firebase ID token for authenticated uploads
            const user = auth.currentUser;
            let token = '';
            if (user) {
                token = await user.getIdToken();
            }

            const headers: Record<string, string> = {};
            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            }

            const response = await fetch(`${API_BASE_URL}${endpoint}`, {
                method: 'POST',
                headers,
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`Upload failed: ${response.statusText}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error uploading file:', error);
            throw error;
        }
    },

    async registerUser(userData: any) {
        try {
            // Get Firebase ID token
            const user = auth.currentUser;
            let token = '';
            if (user) {
                token = await user.getIdToken();
            }

            const response = await fetch(`${API_BASE_URL}/auth/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(userData)
            });

            if (!response.ok) {
                const err = await response.json();
                throw new Error(err.detail || 'Registration failed');
            }

            return await response.json();
        } catch (error) {
            console.error('Registration API error:', error);
            throw error;
        }
    }
};
